import { QuoteOrderModelType } from '@teinor/erp/types/company/order/quote/quoteOrder'
import { connect, ConnectedProps } from 'react-redux'
import CustomError from '../../../../../../../../baseComponents/CustomError'
import { ModalLittle } from '../../../../../../../../baseComponents/Modal'
import { LittleModalCreateEditChildrenFirst } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { checkIfCanCreateQuote } from '../../../../../../../../utils/globals/order/order'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import useCreateQuoteLogic from '../../../../../../../../utils/hooks/quotes/useCreateQuoteLogic'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../../utils/reducers/company/workingCenters'
import { CustomerPayload } from '../../../../../../../../utils/reducers/customers/customer'
import { getSelectedWorkingCenter, getUserPermissions } from '../../../../../../../../utils/reducers/getters'

interface ModalQuoteOrderDuplicateProps extends ModalEditComponentProps { }

const ModalQuoteOrderDuplicate: React.FC<ModalQuoteOrderDuplicateProps> = ({ setOpened, ...rest }) => {
    const { t } = useTwinTranslation()
    const userPermissionsCustomer = getUserPermissions('customer.profile.main')
    if (!permissionCheck(userPermissionsCustomer, 'read')) {
        return <ModalLittle opened={true} setOpened={setOpened}>
            <h2 className='mb-25'>
                <TwinTrans transKey='newQuote'>Nuevo presupuesto</TwinTrans>
            </h2>
            <CustomError textError={t('noPermissionsToSeeCustomers', 'No tienes permisos para ver los clientes')} />
        </ModalLittle>
    }
    return (
        <ModalQuoteOrderDuplicateConnect setOpened={setOpened} {...rest} />
    )
}

interface QuoteOrderModelTypeExtended extends QuoteOrderModelType {
    OrderId: number
}

type ModalQuoteOrderDuplicateAfterPermissionsProps = ModalEditComponentProps & ReduxModalQuoteOrderDuplicateConnector & {}

const ModalQuoteOrderDuplicateAfterPermissions: React.FC<ModalQuoteOrderDuplicateAfterPermissionsProps> = ({ userPermissions, allRowData, workingCenters, customers, ...rest }) => {
    const { t } = useTwinTranslation()
    const workingCenter = getSelectedWorkingCenter()
    const { customerInfo, createQuote, addressFields, myCustomerInfo } = useCreateQuoteLogic({ customers })
    const error = checkIfCanCreateQuote(t, workingCenters?.[workingCenter?.id])
    const fields: FormRender<QuoteOrderModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                ...customerInfo,
                ...myCustomerInfo,
                {
                    name: 'updatePrice',
                    label: t('updatePricesOfProducts', 'Actualizar precios de los productos'),
                    component: 'CheckboxMargin',
                    defaultChecked: true
                },
                {
                    name: 'updateCopyProduct',
                    label: t('updateNameAndDescriptions', 'Actualizar nombre y descripción de los productos'),
                    component: 'CheckboxMargin',
                    defaultChecked: true
                },
                {
                    name: 'copyNotes',
                    label: t('copyNotes', 'Copiar notas'),
                    component: 'CheckboxMargin',
                    defaultChecked: true
                },
                {
                    name: 'CurrencyId',
                    component: 'InputHidden',
                    value: workingCenter?.CurrencyId
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: workingCenter?.id
                },
                {
                    name: 'OrderId',
                    component: 'InputHidden',
                    value: allRowData?.header?.id
                }
            ],
        },
        ...addressFields,
    ]
    return (
        <LittleModalCreateEditChildrenFirst fields={error ? [] : fields} url={'/api/app/order/quote/createQuoteOrder'} translations={{
            title: t('newQuote', 'Nuevo presupuesto'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={!error}  {...{ ...rest, onSubmit: createQuote }}>
            {error ? <CustomError textError={error} /> : null}
        </LittleModalCreateEditChildrenFirst>)
}

const modalQuoteOrderDuplicateDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setCustomers: (payload: CustomerPayload) => ({ type: 'CHANGE_CUSTOMER', payload }),
}
const mapModalQuoteOrderDuplicateConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters, customers: state.customers })
const modalQuoteOrderDuplicateConnector = connect(mapModalQuoteOrderDuplicateConnector, modalQuoteOrderDuplicateDispatch)
type ReduxModalQuoteOrderDuplicateConnector = ConnectedProps<typeof modalQuoteOrderDuplicateConnector>

const modalQuoteOrderDuplicateConnectLoading = withLoading(ModalQuoteOrderDuplicateAfterPermissions, [{ fetchUrl: '/api/app/customer/getAllCustomers', propName: 'customers', setFunctionName: 'setCustomers' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])
const ModalQuoteOrderDuplicateConnect = modalQuoteOrderDuplicateConnector(modalQuoteOrderDuplicateConnectLoading)


export default ModalQuoteOrderDuplicate